export const DEFAULT_FOLDERS = [
  'General',
  'Worksheets & Handouts',
  'Screening Tools',
  'Practice Documents',
  'Client Paperwork',
  'AI Project Assistant',
  'Session Resources',
];

/** Permission explainer messages */
export const PERMISSION_MESSAGES = {
  NOTE_TEMPLATES: 'Only users with admin permissions can create or edit note templates. If you have an idea for a new template or see something that needs changing, send a suggestion to your admin team.',
  FORMS_ADMIN_ONLY: 'Only users with admin permissions can edit practice-wide forms. You can create your own forms and edit your own creations.',
  SCREENING_ADMIN_ONLY: 'Only users with admin permissions can edit practice-wide screening tools. You can create your own screening tools and edit your own creations.',
};
